export enum OrganizationEnumModel {
    package_summary_payment_details_tax = "package_summary_payment_details_tax",
    enableExplorationFeature = "enableExplorationFeature",
    indiaWhastAppNo = "indiaWhastAppNo",
    groupBookingAreaAttribute = "groupBookingAreaAttribute",
    EnableNeedHelpInCheckout = "EnableNeedHelpInCheckout",
    globalWhastAppNo = "globalWhastAppNo",
    whyBookAreaAttribute = "whyBookAreaAttribute",
    filter_package_size = "filter_package_size",
    happyTravelerAttribute = "happyTravelerAttribute",
    package_summary_proceed_payment_btn = "package_summary_proceed_payment_btn",
    whatsAppInquiryContact = "whatsAppInquiryContact",
    offersAttribute = "offersAttribute",
    GPTAPIKey = "GPTAPIKey",
    GoogleMapAPIKey = "GoogleMapAPIKey"
}